const Style = {
  loading: 'opacity-50',
  button: 'w-[49%] inline-block mr-[2%] last:mr-0',
};

export default Style;
